import React from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export const Page: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <React.Fragment>
      <Stack
        className="page"
        sx={{
          height: '297mm', // A4 height in millimeters
          p: 3,
          position: 'relative',
          backgroundColor: 'white',
        }}
      >
        {children}
      </Stack>
    </React.Fragment>
  );
};

export const PageWithHeaderFooter: React.FC<{
  header: string;
  footer: string;
  pages: string;
  children: React.ReactNode;
}> = ({ header, footer, pages, children }) => {
  return (
    <Page>
      <Typography variant="overline" sx={{ mb: 2 }}>
        {header}
      </Typography>
      {children}
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={(theme) => ({
          position: 'absolute',
          bottom: theme.spacing(3),
          left: theme.spacing(3),
          right: theme.spacing(3),
        })}
      >
        <Typography variant="overline">{footer}</Typography>
        <Typography variant="overline">{pages}</Typography>
      </Stack>
    </Page>
  );
};

export default PageWithHeaderFooter;
